import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import translate, { InjectedTranslateProps } from '../../../../utils/translate';
import { validate } from '../../../../utils/validators';
import SubmitButtom from '../../../../components/SubmitButton';
import { actions } from '../../actions';
import { routine } from './actions';
import { selector } from './selectors';
import { FormData, constraints } from './constraints';
import { FieldSet } from 'shared/components/FieldSet';
import { Input } from 'shared/components/Input';
import { PasswordInput } from 'shared/components/PasswordInput';
import { form, FormProps } from 'shared/utils/form';

import './index.scss';

export interface Props {}

const dispatchProps = {
  goBack: () => actions.goToStep('PERSONAL_DATA'),
};

const b = b_.with('login-and-password-form');

type Enhanced = Props &
  InjectedTranslateProps &
  ReturnType<typeof selector> &
  typeof dispatchProps &
  FormProps<FormData, Props>;

const enhance = compose<Enhanced, Props>(
  translate,
  connect(selector, dispatchProps),
  form<FormData, Props>(routine, {
    form: 'fullRegistrationLoginAndPasword',
    validate: (values) => validate(constraints, values),
  })
);

class LoginAndPasswordForm extends React.Component<Enhanced> {
  render() {
    const { t, formSubmit, submitting, error } = this.props;

    return (
      <form onSubmit={formSubmit} method="POST" data-testid="signup-popup-login-and-password-step">
        <FieldSet>
          <Input name="login" label={t('Username')} autoFocus tooltipPlacement="bottomLeftSticky" />
          <PasswordInput name="password" label={t('Password')} />
        </FieldSet>
        <p>{t('Choose login and password')}</p>
        <SubmitButtom
          primary
          className={b('submit-btn')}
          submitting={submitting}
          error={error}
          data-gtm="registrationform-thirdstep-btn"
        >
          {t('Sign Up')}
        </SubmitButtom>
      </form>
    );
  }
}

export default enhance(LoginAndPasswordForm);
